<template>
    <div class="flex items-center justify-start xl:justify-center">
        <PricingPlanBadge :plan-name="planName" />
        <span class="text-body-md xl:text-body-lg font-medium ml-2 text-gray-100">{{ $t(planTitle) }}</span>
        <span
            v-if="userData.active_plan_name === planName && userData.cycle === planCycle"
            class="px-2 py-1 text-body-sm bg-brand-500 rounded-full ml-6"
            >Active</span
        >
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
import type { TPlanNames } from "~/types/global/user.type";
import type { TCycle } from "../../types";

interface IProps {
    planName: TPlanNames;
    planTitle: string;
    planCycle: TCycle;
}
defineProps<IProps>();

const { userData } = storeToRefs(useUserStore());
</script>
